export default __webpack_public_path__ + "static/media/W.f054260a.wav";